import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { Box, Typography } from "@mui/material";
import { BackgroundImage } from "../../../assets/img/widgets/staticWilmaBanner";
import { getActiveWorkspace } from "../../../helpers/selectors";

const MessageLink = ({ to, children }) => {
  if (!to) {
    return (<>{children}</>);
  }

  return (
    <Link
      to={to}
      style={{
        color: "inherit",
        textTransform: "none",
        textDecoration: "none",
      }}
    >
      {children}
    </Link>
  );
};

const StaticWilmaBannerWidget = () => {
  const { name: workspaceName, id: workspaceId } = useSelector(getActiveWorkspace);
  const { companyName } = useSelector(state => state.api.currentViewer.viewer);

  const isMatilda = (workspaceId === 18);

  return (
    <Box
      sx={{
        backgroundImage: `url(${BackgroundImage})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        borderRadius: "6px",
        display: "flex",
        fontFamily: "lato",
        height: "100%",
        padding: "1em 2em",
        position: "absolute",
        width: "100%",
      }}
    >
      <Box sx={{
        margin: "auto 0px",
        paddingLeft: "1em",
        "&::after": {
          content: '""',
          position: "absolute",
          top: "1em",
          bottom: "1em",
          left: "2em",
          width: "2px",
          backgroundColor: "rgba(255, 255, 255, 0.8)",
          boxShadow: "2.57px 3.06px 10px rgba(0, 0, 0, 0.3)",
        },
      }}>
        <Typography variant="h4" sx={{ color: "white", fontFamily: "lato", fontWeight: 600, lineHeight: 1, opacity: 0.94, textShadow: "2.57px 3.06px 10px rgba(0, 0, 0, 0.3)" }}>
          {workspaceName || companyName}
        </Typography>
        {isMatilda && (
          <Typography sx={{ color: "white", fontFamily: "lato", fontSize: "15px", lineHeight: 1.3, opacity: 0.94, textShadow: "2.57px 3.06px 10px rgba(0, 0, 0, 0.3)" }}>
            Matilda är Kommunals nya webbshop<br />
            för beställning av trycksaker.
          </Typography>
        )}
        {!isMatilda && (
          <Typography sx={{ color: "white", fontFamily: "lato", fontSize: "15px", lineHeight: 1.3, opacity: 0.94, textShadow: "2.57px 3.06px 10px rgba(0, 0, 0, 0.3)" }}>
            Kommunals digitala plattform för samarbete,<br />
            kommunikation och materialhantering.
          </Typography>
        )}
      </Box>
      <Box sx={{ margin: "auto 0px 0px auto" }}>
        <Typography sx={{ color: "yellow", fontFamily: "lato", lineHeight: 1.3, opacity: 0.9, textShadow: "2.57px 3.06px 10px rgba(0, 0, 0, 0.3)" }}>
          <MessageLink /*to="/messaging"*/>
            Upptäck hur Wilma kan hjälpa dig »
          </MessageLink>
        </Typography>
      </Box>
    </Box>
  );
};

export default StaticWilmaBannerWidget;
